const en_template = {
    best_regards: "best regards",
    dear: "Dear Sir/Madam,",
    delivered_to: "delivered to",

    no_so: "sales order number",
    no_do: "delivery order number",

    // note
    note_inv_1: "MAKE ALL CHECKS PAYABLE TO",
    note_itemin: "Goods Received Note",

    receipt: "receipt",
    receipt_by_fix: "Received By,",
    receipt_from: "Receipt From",
    received_by: "received by",
    spelled_out: "in words",
    user_input: "user input",

    term_condition: "Terms and Conditions",

    // warehouse
    whs_for: "for warehouse",
    whs_storage: "storage warehouse",
    whs_admin: "Warehouse Admin",
    whs_head: "Warehouse Manager",
    whs_tim: "Warehouse Team",

    // recap
    recap_inv_count: "Total Invoices",
    recap_inv_total: "Total Amount",
    recap_detail: "With Details",

    // planning
    planning_no: "Planning No.",
    planning_date: "Planning Date",
    planning_name: "Planning Name",
    planning_price_ref: "Price Reference",
    planning_qty: "Maximum Quantity",
}

export default en_template;